import React from 'react';

export function BoardSearchPickerShell({ children, footer }) {
  return (
    <div
      className="filter-modal filter-modal--main bsf-popover-modal bsf-cidade-picker"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="filter-modal-content bsf-popover-modal-content bsf-cidade-picker-content">
        {children}
        {footer}
      </div>
    </div>
  );
}
